import packageJson from '../../package.json';

export const APP_VERSION = process.env.REACT_APP_VERSION || packageJson.version;
